export default "__VITE_ASSET__DagUQPCJ__"